<template>
  <div class="home">
    <h1>Веб-клиент для онлайн-квизов, игры мозголомка и похожих онлайн игр</h1>
    <p>Это прототип, веб-приложение которое можно использовать вместо гугл-форм</p>
    <p>Основные фичи</p>
    <ul>
      <li>Можно явно задавать одновременный дедлайн для всех команд</li>
      <li>Можно всем игрокам видеть какие ответы отправляются</li>
      <li>Автоматизированная проверка результатов с возможностью задания нескольких вариантов ответа и ручным контролем</li>
    </ul>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',

}
</script>
